import { API_BASE } from "./client";
import { downloadHeaders } from "./download";

/** Opens a server-rendered print form (HTML) in a new tab. The tab is opened first so the browser
 *  treats it as a user action; the page is fetched with the access token and written into it.
 *  KZ-DOC TMP24: the old form stays for integrators and as a fallback of «Документы и печать»; it goes with the
 *  working organization (`X-Company-Id`) like every other request, so the server checks the same scope. */
export async function openPrintForm(path: string): Promise<void> {
  const tab = window.open("", "_blank");
  const response = await fetch(API_BASE + path, { headers: downloadHeaders() });
  if (!response.ok) {
    tab?.close();
    const text = await response.text();
    let detail = response.statusText;
    try {
      detail = JSON.parse(text).detail ?? detail;
    } catch {
      /* not json */
    }
    throw new Error(detail);
  }
  const html = await response.text();
  if (tab) {
    tab.document.open();
    tab.document.write(html);
    tab.document.close();
  }
}
